import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PostsService {
  public posts$: Observable<any[]>;
  private posts = new BehaviorSubject<any[]>([]);

  constructor() {
    this.posts$ = this.posts.asObservable();
  }

  public setPosts(posts: any) {
    this.posts.next(posts);
  }

  public getPosts(): any {
    return this.posts.value;
  }
}
